export enum PinType {
  UNKNOWN = -1,
  RC = 0,
  COBROWSE = 1
}
